import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ExternalCompanyData, HelpConfiguration } from '@jms/model';
import { Observable } from 'rxjs';

@Injectable()
export class HelpService {
    private readonly baseUrl = 'api/help';

    constructor(private http: HttpClient) { }

    public getConfig(): Observable<HelpConfiguration> {
        return this.http.get<HelpConfiguration>(`${this.baseUrl}/configuration`);
    }

}